import { onMessateTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { InvitationTemplateActivityCard } from "./InvitationTemplateActivityCard";

interface Props {
  invitationTemplateId: number
  config: server.dto.ActivityPanelConfig
}

export const InvitationTemplateActivityPanel = (props: Props) => {

  return <ActivityPanel<server.dto.MessageTemplateActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.MessageTemplate.ListActivity({ itemId: props.invitationTemplateId, page, perPage })}
    renderActivity={(activity => <InvitationTemplateActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onMessateTemplateActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.invitationTemplateId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}